import CreateMatomoIframe from '../../core/CreateMatomoIframe'
import WidgetURLMapping from '../../core/WidgetURLMapping'
import React from 'react'

const OutgoingReferrals = () => {
    return (
        <>
            <CreateMatomoIframe
                headline={'Ausgehende Verweise'}
                width={'100%'}
                height={'600'}
                url={WidgetURLMapping({ name: 'Outgoing referrals' })}
                scrolling={'yes'}
                id={'or1'}
            />
        </>
    )
}

export default OutgoingReferrals
